import type { SupSingleVaultV3, vaultAvailability } from "@/types";
import React from "react";

import UiTooltip from "@/components/Ui/Tooltip";
import UiLabelPlaceholder from "@/components/Ui/Label/Placeholder";

import { twMerge } from "tailwind-merge";
import config from "@/../config/availability.config";

export const AVAILABILITY_DICT = {
  available: 10,
  withdraw_only: 8,
  deposit_only: 6,
  paused: 2,
  unavailable: 0,
  "": -1,
} as Record<vaultAvailability | "", number>;

interface GridCellAvailabilityProps {
  vault: SupSingleVaultV3;
}

export default function GridCellAvailability({ vault }: GridCellAvailabilityProps) {
  const value = vault.availability !== "" ? vault.availability : "available";
  const vaultAvailability = config.vaultAvailabilityTypes.find(option => option.value === value);

  return vaultAvailability ? (
    <UiTooltip content={vaultAvailability.name} color={vaultAvailability.color as "primary" | "info" | "error" | "warning" | "success"}>
      <div className={twMerge("sup-availability-icon", vaultAvailability.className)}>{vaultAvailability.icon}</div>
    </UiTooltip>
  ) : (
    <UiLabelPlaceholder>N/A</UiLabelPlaceholder>
  );
}
